import React, { useState, useCallback, useEffect } from "react";
import useAdminDataStore, { selectCurrentGroupData } from "../../../../store/adminData/adminData";
import ScreenHeader from "../../../../CommonComponents/ScreenHeader";
import TabNav from "../../../../CommonComponents/TabNav/TabNav";
import GeneralAppSettings from "./GeneralAppSettings";
import FanSettings from "./FanSettings";
import ConnectionSettings from "./ConnectionSettings";

const AppSettingsContainer = () => {
  const groupData = useAdminDataStore(selectCurrentGroupData);

  const getStoredTab = useCallback(
    (groupId) => {
      if (!groupId) return "general";
      const stored = localStorage.getItem(`appSettingsTab_${groupId}`);
      if (stored === "fan") return "fan";
      if (stored === "connection" && !!groupData?.connectionRequest)
        return "connection";
      return "general";
    },
    [groupData?.connectionRequest]
  );

  const [tab, setTab] = useState(() => getStoredTab(groupData?.id));

  const handleTabChange = useCallback(
    (key) => {
      setTab(key);
      if (groupData?.id) {
        localStorage.setItem(`appSettingsTab_${groupData.id}`, key);
      }
    },
    [groupData?.id],
  );

  useEffect(() => {
    if (groupData?.id) {
      const storedTab = getStoredTab(groupData.id);
      setTab(storedTab);
    }
  }, [groupData?.id, getStoredTab]);

  const hasConnectionRequest = !!groupData?.connectionRequest;

  const tabItems = [
    {
      key: "general",
      label: "General",
    },
    {
      key: "fan",
      label: "Fan Permissions",
    },
    ...(hasConnectionRequest
      ? [{ key: "connection", label: "Connection" }]
      : []),
  ];

  return (
    <div style={{ width: "100%", height: "100%", padding: "12px" }}>
      <ScreenHeader title="App Settings" />

      <div style={{ paddingTop: "2px" }}>
        <TabNav
          items={tabItems}
          activeKey={tab}
          handleTabChange={handleTabChange}
        />
      </div>

      <div style={{ marginTop: "var(--screen-general-margin)" }}>
        {tab === "general" && <GeneralAppSettings />}
        {tab === "fan" && <FanSettings />}
        {tab === "connection" && <ConnectionSettings />}
      </div>
    </div>
  );
};

export default AppSettingsContainer;
